// Beta data lives only in this page's memory. Refresh restores every seed and
// cannot read, clear or overwrite the owner's existing browser data.
export const isPrivateBeta = import.meta.env.VITE_PRIVATE_BETA === 'true'

export function createMemoryStorage(): Storage {
  const values = new Map<string, string>()
  return {
    get length() { return values.size },
    key: (index: number) => [...values.keys()][index] ?? null,
    getItem: (key: string) => values.get(String(key)) ?? null,
    setItem: (key: string, value: string) => { values.set(String(key), String(value)) },
    removeItem: (key: string) => { values.delete(String(key)) },
    clear: () => values.clear(),
  }
}

export const appStorage: Storage = isPrivateBeta ? createMemoryStorage() : window.localStorage

